<template>
  <transition
    :duration="350"
    name="slide"
    @before-enter="onBeforeEnter"
    @enter="onEnter"
    @after-enter="onAfterEnter"
    @before-leave="onBeforeLeave"
    @after-leave="onAfterLeave"
  >
    <slot />
  </transition>
</template>

<script setup>
const onBeforeEnter = (el) => {
  el.style.height = '0'
}

const onEnter = (el, done) => {
  el.style.height = `${el.scrollHeight}px`
  done()
}

const onAfterEnter = (el) => {
  el.style = ''
}

const onBeforeLeave = (el) => {
  el.style.height = `${el.scrollHeight}px`
}

const onAfterLeave = (el) => {
  el.style.height = ''
}
</script>
